import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { api } from "../apiClient.js";

const Dropdown = ({ label, options
  // : initialOptions
  , value, onChange, name, setOptions = () => { },
  disableAutoFetch = false, // ✅ 預設為 false
  grid_area = "",
  block = "",
}) => {
  // const [options, setOptions] = useState(initialOptions || []);
  const [selectedValue, setSelectedValue] = useState(value || "");
  const [newOption, setNewOption] = useState("");
  const [showInput, setShowInput] = useState(false); // 控制是否顯示輸入框
  const [isOpen, setIsOpen] = useState(false);           // 下拉是否展開
  const rootRef = useRef(null);


  useEffect(() => {
    setSelectedValue(value || "");
  }, [value]);

  useEffect(() => {
    // console.log(`options: ${options}`);
    console.log(`selectedValue: ${selectedValue}`);
  }, [selectedValue])

  // // 當父組件的 options 改變時，更新本地 state
  // useEffect(() => {
  //   setOptions(initialOptions || []);
  // }, [initialOptions]);

  // 從後端獲取特定 category 的選項
  useEffect(() => {
    console.log("useFetchDropdownOptions 傳入的 options:",options);

    if (disableAutoFetch) return; // ✅ 跳過自動載入

    // axios.get(`http://localhost:5000/options/${name}`)
    api.get(`/options/${name}`)
      .then(response => {
        console.log(response.data);
        // ✅ 確保 `options` 格式正確
        const formattedOptions = response.data.map(option => ({
          value: option.value,
          label: option.label
        }));
        console.log("Dropdown fetch formattedOptions:", formattedOptions);
        // ✅ 保留原本的選項，並合併 API 回傳的新選項
        setOptions(prevOptions => {
          const mergedOptions = [...prevOptions];

          // **避免重複新增**
          formattedOptions.forEach(newOption => {
            if (!prevOptions.some(option => option.value === newOption.value)) {
              mergedOptions.push(newOption);
            }
          });

          return mergedOptions;
        });
      })
      .catch(error => {
        console.error(`Error fetching options for ${name}:`, error);
      });
  }, [name]);


  // // **選擇選項時**
  // const handleSelectChange = (e) => {
  //   const selectedValue = e.target.value;
  //   if (selectedValue === "add_new") {
  //     setShowInput(true);
  //     setSelectedValue("");
  //   } else {
  //     setSelectedValue(selectedValue);
  //     const selectedOption = options.find(opt => opt.value === selectedValue);
  //     if (typeof onChange === 'function') {
  //       onChange(selectedOption?.value || selectedValue);
  //     }
  //     // onChange(selectedValue); // **同步父組件**
  //   }
  // };


  // 新增：輸入框 ref（自動聚焦用）
  const inputRef = useRef(null);

  // 當清單打開時，自動聚焦新增輸入框
  useEffect(() => {
    if (isOpen && showInput && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen, showInput]);


  // 點選選項
  const selectValue = (val) => {
    // if (val === "add_new") {
    //   setShowInput(true);
    //   setIsOpen(false);
    //   setSelectedValue("");
    //   return;
    // }
    setSelectedValue(val);
    if (typeof onChange === "function") onChange(val);
    setIsOpen(false);
  };


  useEffect(() => {
    console.log("options:", options)
  }, [options])

  // 新增選項
  const handleAddOption = async (e) => {
    e.preventDefault(); // 防止表單提交
    if (!newOption.trim()) return;

    try {
      console.log("handleAddOption 呼叫 flask");
      console.log("category:", name)
      console.log("value:", newOption)
      // const response = await axios.post("http://localhost:5000/options", {
      const response = await api.post("/options", {
        category: name, value: newOption
      });

      const newOptionObj = {
        value: response.data.value,
        label: response.data.value
      };

      setOptions((prev) => {
        // 避免重覆
        if (prev.some((o) => o.value === newOptionObj.value)) return prev;
        return [...prev, newOptionObj];
      });

      // 1️⃣ 更新下拉選項列表
      // setOptions((prevOptions) => [...prevOptions, newOptionObj]);

      // 2️⃣ 更新內部與外部選取狀態
      setSelectedValue(newOptionObj.value);        // 下拉選單會選中它
      if (typeof onChange === 'function') {
        onChange(newOptionObj.value);              // 通知父層選了新值（value）
      }

      // setOptions((prevOptions) => [
      //   ...prevOptions,
      //   { value: response.data.value, label: response.data.value }
      // ]); // 更新 options

      // 通知父組件更新選項
      // onChange?.(newOption);
      // setSelectedValue(newOption);
      setNewOption("");
      setShowInput(false);
      setIsOpen(false); // ← 關閉下拉

    } catch (error) {
      console.error("Error adding option:", error);
    }
  };


  // 點外面收合
  useEffect(() => {
    const onDocClick = (e) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  const selectedLabel =
    (Array.isArray(options) &&
      options.find((o) => o?.value === selectedValue)?.label) ||
    (selectedValue ? selectedValue : "請選擇");

  return (
    <span ref={rootRef} className={`custom-select ${grid_area} ${block}`}
    // style={{ marginBottom: "16px" }}
    >
      {/* <label htmlFor={name}
      //   style={{ display: "block", marginBottom: "8px" }}
      >
        {label}
      </label> */}
      {/* 隱藏的原生 select：為了表單/可及性（仍保持同步） */}
      <select
        id={name}
        name={name}
        value={selectedValue}
        onChange={(e) => {
          // onChange(e.target.value);
          selectValue(e.target.value);
          // handleSelectChange(e);
        }}
        style={{ display: "none" }}
      // style={{
      //   padding: "8px",
      //   fontSize: "16px",
      //   width: "100%",
      // }}
      // required
      >
        <option value="" disabled>
          請選擇
        </option>

        {/* {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))} */}
        {Array.isArray(options) && options.filter(o => o?.value).map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
        {/* <option value="add_new">➕新增選項</option>  */}
        {/* 新增這個選項 */}
      </select>

      {/* 取代原本 script 生成的 .select-selected */}
      <button
        type="button"
        className={`select-selected ${isOpen ? "select-arrow-active" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(
            // (o) => !o
            (o) => {
              const next = !o;
              if (next) setShowInput(true); // 打開時顯示輸入列並待會自動聚焦
              return next;
            }
          );
        }}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        {selectedLabel}
      </button>

      {/* 取代原本 script 生成的 .select-items */}
      <div className={`select-items ${isOpen ? "" : "select-hide"}`} role="listbox">
        {Array.isArray(options) &&
          options
            .filter((o) => o?.value)
            .map((opt, i) => (
              <div
                key={`${opt.value}-${i}`}
                className={opt.value === selectedValue ? "same-as-selected" : ""}
                onClick={() => selectValue(opt.value)}
                role="option"
                aria-selected={opt.value === selectedValue}
              >
                {opt.label}
              </div>
            ))}
        {/* 這裡改成輸入列；點擊不要冒泡避免馬上關閉 */}
        <div
          className="select-add-row"
          onClick={(e) => e.stopPropagation()}
          style={{
            display: "flex",
            gap: 5,
            alignItems: "center",
            justifyContent: "space-evenly",
            padding: "3px 5px",
            // borderTop: "1px solid rgba(0,0,0,0.1)"
          }}
        >
          <button
            type="button"
            onClick={handleAddOption}
            disabled={!newOption.trim()}
            style={{
              // padding: "6px 10px",
              borderRadius: "15px",
              // border: "1px solid #ddd",
              border: "none",
              background: newOption.trim() ? "#ffffffff" : "#e5e5e5",
              color: newOption.trim() ? "#fff" : "#9ca3af",
              cursor: newOption.trim() ? "pointer" : "not-allowed"
            }}
            aria-label="新增選項"
            title="新增選項"
          >
            ➕
          </button>
          <input
            ref={inputRef}
            type="text"
            placeholder="輸入新選項"
            value={newOption}
            onChange={(e) => {
              if (!showInput) setShowInput(true);
              setNewOption(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleAddOption(e);
              e.stopPropagation(); // 防止影響清單開關
            }}
            style={{
              flex: 1,
              width: "60%",
              // padding: "6px 8px",
              borderRadius: 15,
              // border: "1px solid #ddd",
              background: "#fff",
              // color: "#333"
              textAlign: "center",
            }}
          />
        </div>

        {/* <div
          className={selectedValue === "add_new" ? "same-as-selected" : ""}
          onClick={() => selectValue("add_new")}
          role="option"
          aria-selected={selectedValue === "add_new"}
        >
          ➕新增選項
        </div> */}

      </div>

      {/* 顯示輸入框 */}
      {/* {showInput && (
        <div>
          <input
            type="text"
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
            placeholder="輸入新選項"
          />
          <button type="button" onClick={handleAddOption}>確認新增</button>
          <button type="button" onClick={() => setShowInput(false)}>取消</button>
        </div>
      )} */}
    </span>
  );
};

export default Dropdown;
